/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import type Transition from '@ember/routing/transition';

interface ValidatePermissionsResponse {
  missing_permission?: string;
}

const PREVIEW_INDEX_ROUTE = 'apps.app.standalone.procedures.procedure.preview.index';

class StandaloneProcedureSimulationsRoute extends Route {
  @service declare router: RouterService;
  @service declare appService: AppService;
  @service declare permissionsService: $TSFixMe;

  templateName = 'apps/app/automation/fin-ai-agent/procedures/procedure/preview/simulations';

  reactEnabled() {
    return true;
  }

  async beforeModel(transition: Transition) {
    let appId = this.appService.app.id;

    try {
      let response = await fetch(
        `/teammate_app/sophisticated_tests/validate_permissions?app_id=${appId}`,
      );

      if (response.ok) {
        return;
      }

      if (response.status === 403) {
        let responseData = (await response.json()) as ValidatePermissionsResponse;
        let missingPermission = responseData.missing_permission;

        if (missingPermission === 'external_ai_consent') {
          return;
        }
        if (missingPermission) {
          // The permissions service will handle showing the modal
          // and redirecting when there is no from route
          await this.permissionsService.cancelTransitionAndShowPermissionModal(
            missingPermission,
            transition,
            PREVIEW_INDEX_ROUTE,
          );

          // If there is a from route we still want to transition to it
          // Otherwise we will stay on the current route with a loading spinner
          if (transition.from?.name) {
            this.router.transitionTo(transition.from.name);
          }

          return;
        }
      }

      this.router.transitionTo(PREVIEW_INDEX_ROUTE);
    } catch (e: unknown) {
      this.router.transitionTo(PREVIEW_INDEX_ROUTE);
    }
  }
}

export default ReactRoute(StandaloneProcedureSimulationsRoute, {
  overrideRenderTemplate: false,
});
